namespace('compass.arctic');

compass.requireLib('compass.util.format');

compass.arctic.NavBarWidget = compass.defineWidget(function NavBarWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var _divs = {};
	var _dialog = "undefined";
	var _widgets = {};

	var _menuItems = [
		{ label : 'Edit Account', trigger : 'NavBarWidget.EditAccount' },
		{ label : 'Change Password', trigger : 'NavBarWidget.ChangePassword' },
		{ label : 'Log Out', trigger : 'NavBarWidget.LogOut' }
	];

	this.setupControls = function() {

	};

	var buildLoginMenu = function () {
		var d = _d;
		function clickHandler(trigger) {
			return function(e) {
				e.stopPropagation();
				me.trigger(trigger, _settings.loginInfo);
				menu.hide(100);
			};
		}

		var menuId = compass.generateId();

		var loginAttrs = {
			className : 'account navItem navLink',
			role : 'menuitem',
			tabindex : 0,
			'aria-haspopup' : true,
			'aria-controls' : menuId
		};
		var login = d.div(loginAttrs,
			d.div({ className: 'fa-solid fa-caret-down fa-large' }),
			d.div('&nbsp;' + _settings.loginInfo.name),
			d.div({ className : 'clear' })
		).activate(function(){
			menu.show(100, function() {
				$('body').one('click.accountMenuClose', function(){ menu.hide(100); });
			});
		});

		var menu = d.div({ className: "accountMenu", role : 'menu', id : menuId },
			_.map(_menuItems, function(mi) {
				var item = d.div({ className : 'menuItem', role : 'menuitem', tabIndex : 0 }, mi.label);
				item.activate(clickHandler(mi.trigger));
				return item;
			})
		);
		menu.appendTo(login);

		return login;
	};

	this.setLoggedIn = function (info) {
		_settings.loginInfo = info;

		var login = buildLoginMenu();
		login.insertAfter(_button);
		_button.remove();
	};

	var _button;
	this.render = function(widgetElem) {
		var d = _d;
		_button = d.button({ className : 'navItem loginButton secondaryButton', role : 'menuitem', tabindex : 0 }, 'Log In').activate(showLoginDialog);

		var help_link = '';
		var navBarWrapperClass = 'navBarWrapper clearfix';

		if(_settings.meetingInfo.showHelpTab == "Y"){
			var help_link = [d.div({ className : 'navItem navLink helpTabLink', role : 'menuitem', tabindex : 0 }, 'Help').activate(function(event){
				me.trigger('NavBarWidget.DisplayHelp');
				compass.trackPageView('Help', { src : 'compass.arctic.NavBarWidget' });
			})];
		}
		
		widgetElem.append(
			d.div({className : navBarWrapperClass, role : 'navigation', 'ARIA-role' : 'navigation', 'ARIA-label' : 'Site Menu'},
				d.div({ className : 'navBarLinks', role : 'menubar' },
					help_link,
					_settings.loginInfo ? buildLoginMenu() : _button
				),
				_buildTranslationControl()
			)
		);

		me.setupControls();

		// change the url of the office logo 
		if(_settings.meetingInfo.officeLogos.OFFICE_LOGO_LIGHT && _settings.meetingInfo.officeLogos.OFFICE_LOGO_LIGHT.url && _settings.meetingInfo.officeLogos.OFFICE_LOGO_LIGHT.url.length ){
			var backgroundUrl = "url('" + _settings.meetingInfo.officeLogos.OFFICE_LOGO_LIGHT.url + "')";
			widgetElem.css("background-image", backgroundUrl);
		}
	};

	function _buildTranslationControl() {
		if(_settings.meetingInfo.googleTranslateOn == 'Y'){

			if(_settings.meetingInfo.languages.length > 0) {
				var defaultLanguage = _.find(_settings.meetingInfo.languages, function(lang) { 
					return lang.meeting_default === 'Y';
				});
				_settings.meetingInfo.languageCode = defaultLanguage.hdc_code.toLowerCase();

				if(_settings.meetingInfo.languageCode != 'en') {
					Cookies.get('googtrans', '/en/' + _settings.meetingInfo.languageCode, {
						path: window.location.pathname
					});
				}
			}

			var id = compass.generateId();
			var callback = compass.createGlobalCallback(function() {
				new google.translate.TranslateElement({
					pageLanguage : 'en',
					includedLanguages: 'es,fr,pt',
					layout : google.translate.TranslateElement.InlineLayout.SIMPLE,
					gaTrack : true,
					gaId : compass.gaId
				}, id);
			});

			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = false;
			script.defer = true;
			script.src = '//translate.google.com/translate_a/element.js?cb=' + callback;
			var head = document.getElementsByTagName('head')[0];
			head.appendChild(script);
			return _d.div({ id : id, className : 'googleTranslateWrapper' });
		} else{
			return _d.div({ id : '', className : 'googleTranslateWrapper' });	
		}
	}

	var showLoginDialog = function(){
		var d = _d;
		var content = d.div();
		_widgets.login = new compass.show.LoginWidget(content, { "meetingInfo" : _settings.meetingInfo });

		_widgets.login.bind("LoginWidget.ForgotPasswordRequest", function (event) {
			content.empty();
			_widgets.resetPassword = new compass.account.ResetPasswordWidget(content, {"meetingInfo" : _settings.meetingInfo});
			_widgets.resetPassword.find('input.login').focus();
		});

		_dialog = d.dialog({
			contents: d.div({ className: 'popupDiv' },
				drawDialogHeader('Enter email and password to log in or reset password'),
				content,
				d.div({ className: 'officeLevel_logo' })
			),
			modal: true,
			classes: 'loginPopup NavBarWidget'
		});

	};

	var drawDialogHeader = function (readerContent) {
		var d = _d;
		_divs.headerDiv = d.div({ className: 'showHeader' },
			d.reader(d.h2(readerContent)),
			d.div({ className: 'showName notranslate' }, _settings.meetingInfo.name),
			d.div({ className: 'showDetails secondaryText' },
				d.span({ className: 'showDates' }, _settings.meetingInfo.datesDisplay ),
				d.span({ className: 'showVenue' }, _settings.meetingInfo.site.name ),
				d.span({ className: 'showLocation' },
					_settings.meetingInfo.site.city + ", " + _settings.meetingInfo.site.state
				)
			)
		);

		if(_settings.meetingInfo.hideMeetingSubheader) {
			_divs.headerDiv.find('.showDetails').empty();
		}
		return _divs.headerDiv;
	};

	var _d = jQuery.dom.getContext(this);
}, {
	WUID : 'defaultNavBarWidgetWUID',
	widgetName : 'NavBarWidget',
	loginInfo: false
});

